import React, { useEffect } from 'react';

import { useHistory, useRouteMatch } from 'react-router';

import {isMobile} from 'react-device-detect';


import Image from 'react-bulma-companion/lib/Image';
import Button from 'react-bulma-companion/lib/Button';

import Zev from "_assets/images/Zev.jpeg";
import BackIcon from "_assets/icons/back.svg";

export default function SurveyNav({backward, back = true}) {

  let { path, url } = useRouteMatch();

  useEffect(() => {
    console.log(path);
  }, []);

  return (
      <div className="survey-header">
        <div className="nav-separator">{back && <a className="back-btn" onClick={backward}><Image><Image.Content className="back" src={BackIcon} draggable="false"/></Image></a>}<hr /></div>
        <Image size={isMobile ? "64x64" : "96x96"}>
          <Image.Content className="nav-image" src={Zev} alt="Zev" title="Zev"  draggable="false"/>
        </Image>
        <div className="nav-separator"><hr /></div>
      </div>
  );
}